import {createIconSetFromFontello} from 'react-native-vector-icons';

import fontelloConfig from '../fontello-config';
const FontelloIcon = createIconSetFromFontello(fontelloConfig);

export default FontelloIcon;
